import { createTheme } from "@mui/material/styles";
import { red } from "@mui/material/colors";

const theme = createTheme({
  palette: {
    /* primary: {
      main: "#556cd6",
    },
    secondary: {
      main: "#19857b",
    },*/
    primary: {
      main: "#3490eb",
      contrastText: "#fff",
      /* light: "#338cf5",
      dark: "#004eaa", */
    },
    secondary: {
      main: "#F9A825",
      contrastText: "#000",
    },
    text: {
      main: "#212121",
      light: "#4d4d4d",
      dark: "#171717",
      contrastText: "#fff",
    },
    error: {
      main: red.A400,
    },
    background: {
      default: "#fff",
    },
  },
});

// #546E7A - dark grey/green?

export default theme;
